var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4V10H17",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20V14H7",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 9.00154C4.01717 7.56833 4.87913 6.28694 6.01547 5.27696C7.1518 4.26697 8.52547 3.56131 10.0083 3.2258C11.4911 2.89029 13.0348 2.93588 14.4952 3.35831C15.9556 3.78075 17.2853 4.56625 18.36 5.64154L23 10.0015M1 14.0015L5.64 18.3615C6.71475 19.4368 8.04437 20.2223 9.50481 20.6448C10.9652 21.0672 12.5089 21.1128 13.9917 20.7773C15.4745 20.4418 16.8482 19.7361 17.9845 18.7261C19.1209 17.7161 19.9828 16.4348 20.49 15.0015",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7b99974952a606390553efdcfce0e0ee.svg";
export { ForwardRef as ReactComponent };